export const NO_SECONDS = 0;
export const DAILY_SECONDS = 86400;
export const WEEKLY_SECONDS = DAILY_SECONDS * 7;
export const MONTHLY_SECONDS = WEEKLY_SECONDS * 4;
export const CONTENT_EMAIL_FALLBACK_EMAIL = 'alerts@mg.everyonesocial.com';
